export const loadingTimeout = 12000;
export const BASE_URL =
  process.env.REACT_APP_HGFBAR_EXE_ADMIN_URL || "https://apiadmin.hgfbar.com.br";
